import React, { Fragment } from 'react';

import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Avatar from '@mui/material/Avatar';
import { ExpandMore as DropdownIcon, ExpandLess as CollapseIcon } from '@mui/icons-material';

import styled from 'styled-components';
import { ITokenMetadata } from '@sbgsports/vault-sso-auth';
import { IUserInfo } from '../../../state/user/userOrgRole';
import { Styling, Colors } from '../../../constants';
import { UiSection } from '../../../enums';
import { VaultButton } from '../../Shared';

import {
  SeparatorOverride,
} from '../../Shared/styles/styles';

export interface IProps {
  userInfo: IUserInfo;
  tokenMetadata: ITokenMetadata;
  logoutClicked: () => void;
  isContactInfo: boolean;
  toggleContactInfo: () => void;
}

const Environment = styled.span`
  font-size: ${Styling.HEADER_FONT_SIZE}px;
  color: ${Colors.BLACK_40};
`;

const InfoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: ${Styling.DEFAULT_SPACING_HALVED}px;
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CenteredContent = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const LogoutText = styled.span`
  color: ${Colors.PRIMARY};
`;

const StyledAvatar = styled(Avatar)`
  width: 24px !important;
  height: 24px !important;
  font-size: 10px !important;
  margin-right: ${Styling.DEFAULT_SPACING_HALVED}px;
  background-color: ${Colors.PRIMARY} !important;
  border: 2px solid #fff;
`;

const UserMenu: React.FC<IProps> = (props: IProps) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const userMenuID: string = `${UiSection.Header}.Menu.User`;
  const userButtonMenuID: string = `${UiSection.Header}.Button.User`;

  const logoutButtonID = `${UiSection.Header}.Button.Logout`;
  const environmentID = `${UiSection.Header}.Label.Env`;
  const buildNumberID = `${UiSection.Header}.Label.BuildNumber`;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogoutClicked = () => {
    handleClose();
    props.logoutClicked();
  };

  const {
    userInfo,
    tokenMetadata,
    isContactInfo,
    toggleContactInfo,
  } = props;

  let avatar: React.ReactElement;
  if (userInfo.firstName && userInfo.lastName) {
    const initials = [userInfo.firstName[0], userInfo.lastName[0]];
    avatar = <StyledAvatar>{initials.join('')}</StyledAvatar>;
  } else if (userInfo.firstName) {
    avatar = <StyledAvatar>{userInfo.firstName[0]}</StyledAvatar>;
  }

  // TODO: i18n
  return (
    <Container>
      <VaultButton id={userButtonMenuID} aria-owns={anchorEl ? 'simple-menu' : undefined} variant="transparentOnBlack" aria-haspopup="true" onClick={handleClick}>
        {avatar} {userInfo ? userInfo.displayName : tokenMetadata.nickname} {!anchorEl ? <DropdownIcon /> : <CollapseIcon />}
      </VaultButton>
      <Menu
        id={userMenuID}
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {isContactInfo && (
          <div>
            <MenuItem>
              <CenteredContent
                onClick={toggleContactInfo}
              >
                My Account
              </CenteredContent>
            </MenuItem>
            <SeparatorOverride horizontal color={Colors.BLACK_20} />
          </div>
        )}

        <MenuItem id={logoutButtonID} onClick={handleLogoutClicked}>
          <CenteredContent>
            <LogoutText>Logout</LogoutText>
          </CenteredContent>
        </MenuItem>

        <SeparatorOverride horizontal color={Colors.BLACK_20} />

        <InfoContainer>
          <Environment id={environmentID}>{process.env.REACT_APP_ENV}</Environment>
        </InfoContainer>

        <InfoContainer>
          <Environment id={buildNumberID}>{process.env.REACT_APP_VERSION}</Environment>
        </InfoContainer>
      </Menu>
    </Container>
  );
};

export default UserMenu;
